import {
  PRINT_OFFER,
  SEARCH_CUSTOMER,
  CUSTOMER_RECEIVED,
  RESET_RECEIVED,
} from './constants';

/**
 *
 * @param offer
 * @param price
 * @param name
 * @param contractualCategory
 * @param accessories
 * @param colors
 * @returns {{offer: *, carReplacement: *, contractualCategory: *, price: *, accessories: *, name: *, type: *}}
 */
export function printOffer(
  offer,
  price = null,
  name = null,
  contractualCategory = null,
  accessories = [],
  colors = [],
) {
  return {
    type: PRINT_OFFER,
    offer,
    price,
    name,
    contractualCategory,
    accessories,
    colors,
  };
}

/**
 *
 * @param fiscalCode
 * @returns {{code: *, type: *}}
 */
export function searchCustomer(fiscalCode) {
  return {
    type: SEARCH_CUSTOMER,
    code: fiscalCode,
  };
}

/**
 *
 * @param customer
 * @returns {{type: *, customer: *}}
 */
export function customerLoaded(customer) {
  return {
    type: CUSTOMER_RECEIVED,
    customer,
  };
}

/**
 * Reset customer
 * @returns {{type: *}}
 */
export function resetCustomer() {
  return {
    type: RESET_RECEIVED,
  };
}
